/**
 * The values are used as query arguments when forwarding from onboarding
 * to folio
 */
export const onboardingOrderStatusQueryValues = {
  AwaitingAccount: 'vent-pa-konto',
  AwaitingFollowup: 'vent-pa-e-post',
  AwaitingProcessing: 'vent-pa-behandling',
} as const;
